/**
 * @namespace PIXI.accessibility
 */
export { default as accessibleTarget } from './accessibleTarget';
export { default as AccessibilityManager } from './AccessibilityManager';
